import { NgFor, NgIf } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ReactiveFormsModule, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { ModalComponent } from "../../../_shared/components/layout/modal/modal.component";
import { BaseModal } from "../../../_shared/components/layout/pages/base-modal";
import { ButtonComponent } from "../../../_shared/form/components/button/button.component";
import { HorizontalTextInputComponent } from "../../../_shared/form/components/horizontal-text-input/horizontal-text-input.component";
import { RadioComponent } from "../../../_shared/form/components/radio/radio.component";
import { GlobalVariables } from "../../../_shared/services/global.service";
import { SubscriptionDto } from "../../../organisation/models/subscription";
import { StartsettingsService } from "../../../organisation/services/startsettings.service";
import { SubscriptionRenewModalComponent } from "../../../subscription/pages/subscription-renew-modal/subscription-renew-modal.component";
import { LoginFormModel } from "../../form-models/login-form-model";
import { UserOrganizationList } from "../../models/userOrganization";
import { UserService } from "../../services/user.service";

@Component({
  selector: "app-login-modal",
  templateUrl: "./login-modal.component.html",
  styleUrls: ["./login-modal.component.scss"],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    HorizontalTextInputComponent,
    ButtonComponent,
    RadioComponent,
    NgFor,
    ModalComponent,
  ],
})
export class LoginModalComponent extends BaseModal implements OnInit {
  form: LoginFormModel = new LoginFormModel();
  failed: boolean = false;
  organizations: UserOrganizationList[] = [];
  step = 1;
  microsoftLoginUrl: string = "";

  constructor(
    protected override route: ActivatedRoute,
    protected override modal: NgbModal,
    @Inject("BASE_URL") protected baseUrl: string,
    @Inject("APP_KEY") protected appKey: string,
    protected override activeModal: NgbActiveModal,
    private userService: UserService,
    private startsettingService: StartsettingsService
  ) {
    super(activeModal, route, modal);
    this.global = GlobalVariables;
    // Get the current URL
    let currentUrl = window.location.href;
    // Check if the URL contains a route
    if (!currentUrl.includes("/#/")) {
      // Replace the current URL with /#/welkom if it doesn't contain a route
      currentUrl = window.location.origin + "/#/welkom";
    }

    // Append the access key to the URL
    const returnUrl = encodeURIComponent(currentUrl + "?accessKey=[usertoken]");
    this.microsoftLoginUrl = `${this.baseUrl.replace("/api", "")}/mvc/Account/ExternalLogin?provider=Microsoft&returnUrl=${returnUrl}&applicationKey=${appKey}`;
  }

  ngOnInit(): void {
    this.isLoading = false;
  }

  login() {
    if (this.form.valid) {
      this.isLoading = true;
      var thrustKey = localStorage.getItem("thrustKey");
      if (this.form.Code.value || thrustKey) {
        this.loginUser(thrustKey);
      } else {
        var model = this.form.mapToModel();

        if (this.form.Thrust.value) {
          model.ThrustKey = uuidv4();
          localStorage.setItem("thrustKey", model.ThrustKey);
        }

        this.userService.hasMfa(this.form.mapToModel()).subscribe((hasMfa) => {
          if (hasMfa) {
            this.focus("Code");
            this.isLoading = false;
            this.step = 3;
            this.form.Code.setValidators([Validators.required]);
          } else this.loginUser();
        });
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  loginUser(thrustKey: string | null = null) {
    var model = this.form.mapToModel();
    if (thrustKey) model.ThrustKey = thrustKey;
    else if (this.form.Thrust.value) {
      model.ThrustKey = uuidv4();
      localStorage.setItem("thrustKey", model.ThrustKey);
    }

    this.userService.login(model).subscribe(
      (data) => {
        this.failed = false;

        this.userService.getUserOrganizations().subscribe((orgs) => {
          this.isLoading = false;
          if (orgs && orgs.length > 1) {
            this.organizations = orgs;
            this.step = 2;
          } else {
            window.location.reload();
          }
        });
      },
      (error) => {
        this.isLoading = false;
        this.failed = true;
      }
    );
  }

  loginAs(org: UserOrganizationList) {
    org.isLoading = true;
    this.userService.loginAs(org).subscribe(() => {
      this.startsettingService.getCurrent().subscribe((data) => {
        org.isLoading = false;
        this.global.startSettings = data;
        this.global.organization = data.Organization;
        window.location.reload();
      });
    });
  }

  showSubscriptionModal(subscription: SubscriptionDto) {
    var modal = this.modal.open(SubscriptionRenewModalComponent, {
      size: "lg",
    });
    modal.dismissed.subscribe((x) => {
      if (subscription.IsActive) window.location.reload();
      else this.showSubscriptionModal(subscription);
    });
  }
}
